import { isCustomDomainBrowserHost } from '@platzona/auth-client';

/** Hosts that serve the SaaS owner/Kunde app shell itself, not a tenant's published site. */
export const SAAS_APP_HOSTS = ['localhost', '127.0.0.1', 'web.platzona.ai'] as const;

/** True when the current browser host is a tenant custom domain, not the app shell. */
export function isOnCustomDomainHost(): boolean {
  return isCustomDomainBrowserHost(SAAS_APP_HOSTS);
}
